<template>
    <el-dialog
        :title="'在途登记'"
        width="80%"
        :visible="visible"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose"
        :custom-class="'performanceDispatchTransitRegistrationDialog'"
    >
        <div slot="title" class="header-title">
            <span
                >发车单号：<span
                    >{{ componentsData.dispatchNo }} / 司机：{{
                        componentsData.driver
                    }}
                    / {{ componentsData.vehicleCard }} /
                    {{ componentsData.driverContactWay }}</span
                ></span
            >
        </div>
        <div class="content">
            <div class="order-content">
                <div class="title">订单信息：</div>
                <el-table
                    v-loading="loading"
                    :data="taskTableData"
                    border
                    :height="300"
                    highlight-current-row
                    ref="moduleTable"
                    @row-click="rowClick"
                    @select="handleSel"
                    @selection-change="handleSelChange"
                >
                    <el-table-column
                        fixed="left"
                        type="selection"
                        width="40"
                        :selectable="selectable"
                    ></el-table-column>
                    <el-table-column
                        show-overflow-tooltip
                        label="客户订单号"
                        prop="customerOrderNo"
                        min-width="110"
                    ></el-table-column>
                    <el-table-column
                        show-overflow-tooltip
                        label="运单号"
                        prop="taskNo"
                        min-width="100"
                    ></el-table-column>
                    <el-table-column
                        show-overflow-tooltip
                        label="状态"
                        prop="taskStatusName"
                        min-width="60"
                    ></el-table-column>
                </el-table>
            </div>
            <div class="register-content">
                <div class="title">路由登记：</div>
                <el-form
                    :model="formData"
                    :rules="formRules"
                    ref="form"
                    label-width="90px"
                >
                    <el-form-item label="三级地址：" prop="addressInfo">
                        <addressCascader
                            :minLayers="3"
                            v-model="formData.addressInfo"
                            :disabled="isDisabled"
                            @getAddress="getAddress"
                            placeholder="请选择三级地址"
                        ></addressCascader>
                    </el-form-item>
                    <el-form-item label="详细地址：" prop="address">
                        <div class="address-info">
                            <el-input
                                type="text"
                                v-model="formData.address"
                                :disabled="isDisabled"
                                placeholder="请输入详细地址"
                                resize="none"
                                class="address-class"
                                maxlength="30"
                                show-word-limit
                            ></el-input>
                            <i
                                class="el-icon-location-information map-icons"
                                title="地图选点"
                                @click="
                                    openAddressMap(formData.address, 'sender')
                                "
                            ></i>
                        </div>
                    </el-form-item>
                    <el-form-item
                        label="预计时间："
                        prop="expectedDeliveryTime"
                    >
                        <el-date-picker
                            v-model="formData.expectedDeliveryTime"
                            :disabled="isDisabled"
                            placeholder="预计到达时间"
                            type="datetime"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="备注：" prop="remark">
                        <el-input
                            type="textarea"
                            v-model="formData.remark"
                            maxlength="30"
                            show-word-limit
                        ></el-input>
                    </el-form-item>
                    <el-form-item class="form-button">
                        <el-button @click="resetForm">重置</el-button>
                        <el-button
                            type="primary"
                            :disabled="isDisabled"
                            :loading="btnLoading"
                            @click="handleSubmit"
                            >保存</el-button
                        >
                    </el-form-item>
                </el-form>
            </div>
            <div class="history-content">
                <div class="title">历史记录：</div>
                <div class="info-content">
                    <div
                        v-for="(info, index) in infoList"
                        :key="index"
                        class="info"
                    >
                        <div class="info-index">
                            <span class="serial-number">{{
                                infoLength - index
                            }}</span>
                        </div>
                        <div class="info-center">
                            <div>运输单号：{{ info.taskNo }}</div>
                            <div>详细地址：{{ info.trackingLocationName }}</div>
                            <div>
                                预计到达： {{ info.expectedDeliveryTime }}
                            </div>
                            <div>备注： {{ info.remark }}</div>
                            <div class="info-register">
                                登记：{{ info.updateUserName }} /
                                {{ info.updateTime }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 地图选址 -->
        <address-map-modal
            ref="addressMapRef"
            @setSelectedAddress="setSelectedAddress"
        ></address-map-modal>
    </el-dialog>
</template>
<script>
import dayjs from 'dayjs';
import AddressCascader from '@/components/lots/addressCascader';
import { formData, formRules } from './config.js';
import { getTaskData, queryIotPointByDispatchNoAndTaskNo, saveOnWayPositionTrace } from '@/modules/transport/otp/api/performanceDispatchMgmt.js';
import { dictWithUrl } from '@/components/lots/api.js';
import addressMapModal from '../addressMapModal/AddressMapModal';
import { mapState } from 'vuex';
import { formatTotalDataList } from './util.js';
export default {
    name: 'performanceDispatchTransitRegistrationDialog',
    components: { AddressCascader, addressMapModal },
    props: {
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            loading: false, // 表格加载动画
            visible: false, // 是否显示弹窗
            btnLoading: false, // 确定按钮加载动画
            formData: JSON.parse(JSON.stringify(formData)), // 表单数据
            formRules, // 表单校验规则
            taskTableData: [], // 订单信息
            infoList: [], // 历史记录
            currentRow: {}, // 当前行数据
            selectedData: [], // 选中数据
            dictData: {}, // 数据字典
            infoLength: 0 // 历史记录数据长度
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.user
        }),
        // 路由登记是否禁用，未选中数据或选中数据存在运单状态不为在途时，禁用
        isDisabled () {
            return this.selectedData.length <= 0 || this.selectedData.some(v => +v.taskStatus !== 40);
        }
    },
    methods: {
        /**
         * @description 获取数据字典
         * TMS_TASK_STATUS: 运输单状态
         */
        async getDictData () {
            const dict = await dictWithUrl('TMS_TASK_STATUS');
            this.dictData = dict.data || {};
        },
        // 查询订单信息
        getTaskData () {
            this.loading = true;
            getTaskData({ dispatchNo: this.componentsData.dispatchNo }).then(res => {
                if (res && +res.code === 0) {
                    this.taskTableData = formatTotalDataList(res.data || [], this.dictData);
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        // 查询历史记录
        getInfoData () {
            const params = {
                dispatchNo: this.componentsData.dispatchNo,
                taskNo: this.currentRow.taskNo
            };
            queryIotPointByDispatchNoAndTaskNo(params).then((res) => {
                if (res && +res.code === 0) {
                    this.infoList = res.data || [];
                    this.infoLength = this.infoList.length;
                    if (this.infoLength <= 0) {
                        this.$message.warning('没有历史记录信息');
                    }
                }
            });
        },
        // 表格-行点击事件
        rowClick (row) {
            this.currentRow = row;
            if (+row.taskStatus === 40) {
                row.checked = !row.checked;
                // 切换行选中状态
                this.$refs.moduleTable.toggleRowSelection(row, row.checked);
            }
        },
        // 表格-行勾选事件
        handleSel (selection, row) {
            this.currentRow = row;
        },
        // 表格-选择项发生变化时触发事件
        handleSelChange (data) {
            this.selectedData = data;
            // 只支持单条查询历史记录,否则清空历史记录
            if (this.selectedData.length === 1) {
                this.currentRow = this.selectedData[0];
                this.getInfoData();
            } else if (this.selectedData.length === 0) {
                this.resetForm();
                this.infoList = [];
            } else {
                this.infoList = [];
            }
        },
        // 表格-行是否可选
        selectable (row, index) {
            return +row.taskStatus === 40;
        },
        // 点击位置图标打开选址弹窗
        openAddressMap (address, type) {
            const wholeAddress = this.formData.locationDistrict + address;
            this.$nextTick(() => {
                this.$refs.addressMapRef.open(wholeAddress, type);
            });
        },
        // 地图选址回调
        setSelectedAddress (address, type) {
            this.formData.addressInfo = [address[`${type}ProvinceCode`], address[`${type}CityCode`], address[`${type}DistrictCode`]];
            const valid = this.formData.addressInfo.some(v => v !== ('' || null));
            // 移除地址项校验结果
            if (valid) {
                this.$refs.form.clearValidate('addressInfo');
            }
            this.formData.locationDistrict = [address[`${type}ProvinceName`], address[`${type}CityName`], address[`${type}DistrictName`]].join('');
            this.formData.address = address.address;
        },
        /**
     * @description 获取地址名称
     * @param {Array} data
     * */
        getAddress (data) {
            if (data.length) {
                this.$refs.form.clearValidate('addressInfo');
            }
            this.formData.locationDistrict = data[0] + data[1] + data[2];
        },
        // 重置按钮
        resetForm () {
            this.$refs.form.resetFields();
            this.getAddress([]);
        },

        /**
     * @description 提交参数
     */
        getSubmitParams () {
            const taskNos = this.selectedData.map((el) => el.taskNo);
            const expectedDeliveryTime = this.formData.expectedDeliveryTime ? dayjs(this.formData.expectedDeliveryTime).format('YYYY-MM-DD HH:mm:ss') : '';
            const params = {
                ...this.formData,
                dispatchNo: this.componentsData.dispatchNo,
                taskNos: taskNos,
                positionDate: dayjs().format('YYYY-MM-DD HH:mm:ss'), // 在途打点时间
                expectedDeliveryTime: expectedDeliveryTime
            };
            for (const k in params) {
                if (params[k] === '') {
                    delete params[k];
                }
            }
            // 删除省市区编码，后端接口不需要
            delete params.addressInfo;
            return params;
        },

        // 保存按钮
        handleSubmit () {
            this.$refs.form.validate(valid => {
                if (valid) {
                    if (this.selectedData.length <= 0) {
                        return this.$message.warning('请勾选要保存的运单');
                    }
                    const reqParams = this.getSubmitParams();
                    this.btnLoading = true;
                    saveOnWayPositionTrace(reqParams).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('操作成功');
                            this.beforeClose();
                        }
                    }).catch(() => { this.btnLoading = false; });
                }
            });
        },

        // 关闭
        beforeClose () {
            this.$emit('components-close');
        }
    },
    async mounted () {
        this.visible = true;
        await this.getDictData();
        this.getTaskData();
    }
};
</script>
<style lang="less">
.performanceDispatchTransitRegistrationDialog {
    .content {
        display: flex;
        font-size: 14px;
        .title {
            height: 36px;
            line-height: 36px;
        }
    }
    .order-content {
        width: 350px;
        padding-right: 10px;
    }
    .history-content {
        width: 380px;
        padding-left: 10px;
        .info-content {
            height: 350px;
            overflow: auto;
            .info {
                display: flex;
                padding: 10px;
                border-bottom: 1px dashed #ccc;
                .info-index {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 40px;
                    color: #686a6a;
                    font-size: 30px;
                    margin-right: 10px;
                }
                .info-center {
                    flex: 1;
                }
            }
        }
    }
    .register-content {
        flex: 1;
        padding: 0 10px 0 10px;
        border-left: 1px dashed #ccc;
        border-right: 1px dashed #ccc;
    }
    .address-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .address-class {
            flex: 1;
        }
        .map-icons {
            margin-left: 10px;
            color: #00bcbf;
            font-size: 20px;
            cursor: pointer;
        }
    }
    .form-button {
        margin: 30px 0 0 -90px;
        text-align: center;
    }

    .el-dialog__body {
        padding-right: 30px;
        padding-top: 20px;
        .el-form-item {
            margin-bottom: 15px;
            .el-date-editor.el-input,
            .el-date-editor.el-input__inner {
                width: 100%;
            }
        }
    }
    .el-dialog__footer {
        padding-right: 30px;
    }
}
</style>
